// Footer.jsx
import React from 'react';

function Footer() {
    return (
        <div className="footer navbar navbar-sm border-top">
            <div className="container-fluid">
                <span>&copy; TABATA TECH </span>
            </div>
        </div>
    );
}

export default Footer;
